export const PREVIOUS_WORK_LS_KEY = `previousWork`;
export const PREVIOUS_WORK_WIDGET_PREFS_LS_KEY = `previousWorkWidgetPrefs`;
export const PREVIOUS_WORK_MAX_ENTRIES = 30;
